export const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
